import { TypeChecker } from '@attain-apps/type-guards'

import * as expression from '../../../expression'

import { Node } from './node'

export class ForValue<T> extends Node {
  public readonly value: T

  constructor(params: ForValue.constructor.Params<T>) {
    super(params)
    this.value = params.value
  }

  /**
   * Represents {@link this.value} as a {@link expression.node.ForValue}
   */
  public toExpression(): expression.node.ForValue<T> {
    return new expression.node.ForValue(this.value)
  }
}
export namespace ForValue {
  export const isForValue: TypeChecker<ForValue<unknown>> =
    TypeChecker.Factory.instance(ForValue).usingAlias(
      'query.graph.node.ForValue',
    )

  export namespace constructor {
    export interface Params<T> extends Node.constructor.Params {
      value: T
    }
  }
}
